export default "__VITE_ASSET__pc9k2lMz__"